var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInprogressCourseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 4,
    fill: "#EDAB00",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16675,
    y: 1,
    width: 55,
    height: 55,
    rx: 3.5,
    stroke: "#EDAB00",
    strokeOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1747 28.7987C28.2005 26.5464 30.0788 24.7936 32.3967 23.926C34.7145 23.0584 37.2821 23.1469 39.5347 24.172C41.7871 25.1978 43.5398 27.0761 44.4074 29.394C45.275 31.7119 45.1865 34.2794 44.1614 36.532C43.4221 38.1641 42.2275 39.5481 40.7208 40.5178C39.2142 41.4875 37.4598 42.0017 35.6681 41.9987C32.0681 41.9987 28.7747 39.9187 27.2281 36.6654H14.3347V33.9987C14.4147 32.4787 15.4547 31.2387 17.4547 30.2387C19.4547 29.2387 21.9614 28.7187 25.0014 28.6654C25.7614 28.6654 26.4814 28.732 27.1747 28.7987ZM25.0014 15.332C26.4947 15.372 27.7481 15.892 28.7481 16.892C29.7481 17.892 30.2414 19.1454 30.2414 20.6654C30.2414 22.1854 29.7481 23.4387 28.7481 24.4387C27.7481 25.4387 26.4947 25.932 25.0014 25.932C23.508 25.932 22.2547 25.4387 21.2547 24.4387C20.2547 23.4387 19.7614 22.1854 19.7614 20.6654C19.7614 19.1454 20.2547 17.892 21.2547 16.892C22.2547 15.892 23.508 15.372 25.0014 15.332ZM35.6681 39.332C37.4362 39.332 39.1319 38.6297 40.3821 37.3794C41.6323 36.1292 42.3347 34.4335 42.3347 32.6654C42.3347 30.8973 41.6323 29.2016 40.3821 27.9513C39.1319 26.7011 37.4362 25.9987 35.6681 25.9987C33.8999 25.9987 32.2042 26.7011 30.954 27.9513C29.7038 29.2016 29.0014 30.8973 29.0014 32.6654C29.0014 34.4335 29.7038 36.1292 30.954 37.3794C32.2042 38.6297 33.8999 39.332 35.6681 39.332ZM34.3347 28.6654H36.3347V32.4254L39.5881 34.3054L38.5881 36.0387L34.3347 33.5854V28.6654Z",
    fill: "#EDAB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogressCourseIcon);
export default __webpack_public_path__ + "static/media/inprogress-course-icon.5e9b04c09ff516833b0232df2ea002c9.svg";
export { ForwardRef as ReactComponent };